module.exports = __webpack_public_path__ + "fonts/DM_Sans-900-latin19.7c87a64.woff2";